import { useLocation } from 'react-router';

export function useIsDefaultLocation() {
  const location = useLocation();
  const isDefaultLocation: boolean = location.key === 'default';

  return isDefaultLocation;
}
